// Recent-searches thunk — backs the landing-page list and the "View all"
// page. Kept separate from polarisThunks (which is search-scoped and near the
// file-length limit) and re-exported from there.
import {createAsyncThunk} from "@reduxjs/toolkit";
import polarisApi from "api/polarisApi";
import {TPolarisSearchStatus} from "api/polarisApi/types";
import {ensureOk} from "./thunkUtils";

// Loads one page of the recent-searches list (offset/limit), backing both the
// landing-page preview and the paginated "View all" page. status, when set,
// filters the list to that lifecycle status (server-side).
export const loadRecentSearches = createAsyncThunk(
	"polaris/loadRecentSearches",
	async (pagination: {limit?: number; offset?: number; status?: TPolarisSearchStatus} | void) =>
		ensureOk(
			await polarisApi.getRecentSearches({
				limit: pagination?.limit ?? 10,
				offset: pagination?.offset ?? 0,
				...(pagination?.status ? {status: pagination.status} : {}),
			}),
			"Could not load recent searches",
		),
);
